export default {
      id: "i-yt-circle-dark-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/sprite.svg#i-yt-circle-dark",
      toString: function () {
        return this.url;
      }
    }